import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getIdentityInfo } from 'flow/utils/call-record-utils';
import { selectCallRecordFromKey } from 'flow/selectors/call-selectors';
import { CallRecordKey } from 'flow/types/EntityKeys';
import CardCallDetailsContainer from 'flow/components/pbx/v2/misc/CardCallDetailsContainer';
import CopyButton from 'flow/components/pbx/v2/misc/CopyButton';

interface Props {
    callRecordKey: CallRecordKey;
}

const SectionCounterpartVerification = ({ callRecordKey }: Props) => {
    const callRecord = useAppSelector((state) =>
        selectCallRecordFromKey(state, callRecordKey),
    );
    const identityInfo = callRecord ? getIdentityInfo(callRecord) : null;
    const { i18next } = useAppContext();

    if (!identityInfo) return null;

    return (
        <CardCallDetailsContainer className="items-center justify-between">
            <div className="flex items-center gap-2 text-sm text-gray-700 antialiased">
                <Icon
                    iconKey="gppGood"
                    size="1.25rem"
                    className="text-gray-600"
                />
                <span>
                    {i18next.t('identity.verified.with', {
                        authenticatorType: identityInfo.authenticatorType,
                    })}
                </span>
            </div>
            {identityInfo.orderRef && (
                <div className="flex items-center gap-2 text-sm text-gray-800 antialiased">
                    <span>{i18next.t('identity.id_masked')}</span>
                    <CopyButton text={identityInfo.orderRef} />
                </div>
            )}
        </CardCallDetailsContainer>
    );
};

export default SectionCounterpartVerification;
